import 'jquery-ui/ui/widgets/slider.js';
var CryptoJS = require("crypto-js");

/**
 * Returns the URL parameter value
 * 
 * @param {string} sParam The name of the parameter to check
 * @returns {string} The value of the parameter
 */
function GetURLParameter(sParam) {
    var sPageURL = window.location.search.substring(1);
    var sURLVariables = sPageURL.split('&');
    for (var i = 0; i < sURLVariables.length; i++) 
    {
        var sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] == sParam) 
        {
            return sParameterName[1];
        }
    }
}

/**
 * Populates the form with values
 * 
 * @param {string} frm The class name of the form to target
 * @param {Array} data Array of keys & values for the form 
 */
function formPopulate(frm, formDataEncrypt) {
    let data_key = 'BlokFormPrefill';
    let formDataDecrypt = CryptoJS.AES.decrypt(formDataEncrypt, data_key).toString(CryptoJS.enc.Utf8);
    var formData = JSON.parse(formDataDecrypt);

    $.each(formData, function(key, value) {
        var ctrl = $('[name="'+key+'"]', frm);
        var wrapper_class = '';

        if (Array.isArray(formData[key])) {
        	$.each(value, function(inner_key, inner_value) {
		        var ctrl = $('[name="'+key+'['+inner_value+']"]', frm);
		        switch(ctrl.prop("type")) {
                    case "radio": case "checkbox": 
		            	//ctrl.attr('checked', 'checked')  
		            	ctrl.trigger('click');  
		                break;
		        }  
		    }); 
        } else {
        	switch(ctrl.prop("type")) {
	            case "radio":
	            	//ctrl.attr('checked', 'checked')  
	            	$('[name="'+key+'"][value="'+value+'"]', frm).trigger('click');  
	                break;
	             default:
	             	ctrl.val(value); 
	        }            
        }        
    });  
}

/**
 * Returns a URI encoded JSON string of the form fields & values
 * 
 * @param {string} form The form object
 * @returns URI encoded JSON string
 */
function objectifyForm($form){
    let rObject = {};
    let formDataJson = '';
    let formDataEncrypt = '';
    let data_key = 'BlokFormPrefill';

    // Exclude & serialize fields to an Array
    // Exclude if has classname .prefill-skip || if no value
    let formFieldsArray = $form.find(':not(.prefill-skip)').serializeArray().filter(function(field) {
        return $.trim(field.value) != "";
    })

    for (var i = 0; i < formFieldsArray.length; i++){    	

    	var field_name = formFieldsArray[i]['name'];

        // If checkboxes - code can be removed
        if( field_name.match(/\[[0-9]+\]$/) ){

        	var checkbox = field_name.match(/\[[0-9]+\]$/);
        	var checkbox_value = checkbox[0].match(/\d+/);

            var tmp = field_name.substr(0, field_name.length-checkbox[0].length); // only get the field name

            if(Array.isArray(rObject[tmp])){
                rObject[tmp].push(formFieldsArray[i]['value']);
            } else{
                rObject[tmp] = [];
                rObject[tmp].push(formFieldsArray[i]['value']);
            }
        } else{
            rObject[field_name] = formFieldsArray[i]['value'];
        }
    }
    // Convert to JSON string && then encrypt
    formDataJson = JSON.stringify(rObject);    
    formDataEncrypt = CryptoJS.AES.encrypt(formDataJson, data_key).toString();

    return formDataEncrypt;
}

/**
 * Updates the slider values and labels 
 * @param {object} $priceSlider The slider object
 * @param {Array} priceRangeValues The Array of new values
 */
function rangeSliderLabels($priceSlider, priceRangeValues) {

    $priceSlider.find('label').remove();

    // Get the options for this slider (specified above)
    var opt = $priceSlider.data().uiSlider.options;
    // Get the number of possible values
    var vals = opt.max - opt.min;

    // Position the labels
    for (var i = 0; i <= vals; i++) {
        var labelTxt = '';
        // Set price for first & last label
        if(i == 0 || i == vals) {
            var labelTxt = priceRangeValues[i + opt.min].toLocaleString();
        }
        
        // Create a new element and position it with percentages
        var el = $('<label>' + (labelTxt) + '</label>').css('left', (i/vals*100) + '%');
        // Add the element inside #slider
        $priceSlider.append(el);

    }
}

// Doc Ready
$(function() {

    var $formRYI = $('#register-interest');

    if ( $formRYI.length ) {

        // check url param if form should be populated with given data
		if( document.location.search.length && GetURLParameter('form_prefill') == 1 ) {
			var form_data = GetURLParameter('form_data');
			formPopulate($formRYI, form_data);
		}

        // Price range slider
        // Ref: different step size 
        // https://stackoverflow.com/questions/967372/jquery-slider-how-to-make-step-size-change
        var $priceSlider = $( "#price-range-slider:not([data-type='filter'])" );
        
        if ( $priceSlider.length ) {
            var $priceValues = $('.price-range-values:not([data-type="filter"])');
            var priceRangeValues = [];
            // Budgets
            var priceCashBudgetvalues = [1000000, 3500000, 6000000, 8500000, 10000000, 12500000, 15000000];
            var bondBudgetvalues = [6000, 100000, 200000, 400000, 600000, 800000, 1000000];

            // Check default values
            var budgetDefault =  $formRYI.find("input[name='budget']:checked").val();
            // Get default value -> convert to string -> remove all non numeric charachters -> convert to int
            var priceMinDefault =  ( $priceValues.find('#price-range-min').val() ) ? parseInt($priceValues.find('#price-range-min').val().toString().replace( /\D+/g, '')) : '';
            var priceMaxDefault =  ( $priceValues.find('#price-range-max').val() ) ? parseInt($priceValues.find('#price-range-max').val().toString().replace( /\D+/g, '')) : '';

            // Set the default price range
            switch (budgetDefault) {
                case 'Monthly bond repayment budget':
                    priceRangeValues = bondBudgetvalues;
                    break;

                case 'Cash':
                default:
                    priceRangeValues = priceCashBudgetvalues;
                    break;
            }

            // Get default min & max values
            var minValue = (priceMinDefault) ? priceRangeValues.indexOf(priceMinDefault) : 0;
            var maxValue = (priceMaxDefault) ? priceRangeValues.indexOf(priceMaxDefault) : priceRangeValues.length - 1;
            
            // Init slider & set Price bond as default
            $priceSlider.slider({
                range: true,
                min: 0,
                max: priceRangeValues.length - 1,
                values: [ minValue, maxValue], // Default step values
                //step: 2500000,
                // On create
                create: function( event, ui ) {
                    
                    var priceMin =  $priceSlider.slider("option", "min");
                    var priceMax=  $priceSlider.slider("option", "max");
                    var priceMinFormatted = (priceMinDefault) ? priceMinDefault.toLocaleString() : priceRangeValues[priceMin].toLocaleString();
                    var priceMaxFormatted = (priceMaxDefault) ? priceMaxDefault.toLocaleString() : priceRangeValues[priceMax].toLocaleString();

                    $priceValues.find('#price-range-min').val(priceMinFormatted);
                    $priceValues.find('#price-range-max').val(priceMaxFormatted);

                    // Add Slider Labels
                    rangeSliderLabels($priceSlider, priceRangeValues);
                },
                // On Change
                slide: function( event, ui ) {
                    var priceMinFormatted = priceRangeValues[ui.values[0]].toLocaleString();
                    var priceMaxFormatted = priceRangeValues[ui.values[1]].toLocaleString();
                    $priceValues.find('#price-range-min').val(priceMinFormatted);
                    $priceValues.find('#price-range-max').val(priceMaxFormatted);
                }
            });

            // Price range options change
            $formRYI.find('.budget-options input').on('change',function(){
                var optionValue = $(this).val();

                switch (optionValue) {
                    case 'Monthly bond repayment budget':
                        priceRangeValues = bondBudgetvalues;
                        break;
                
                    default:
                        priceRangeValues = priceCashBudgetvalues;
                        break;
                }

                // Update values
                var priceMinFormatted = priceRangeValues[0].toLocaleString();
                var priceMaxFormatted = priceRangeValues[priceRangeValues.length - 1].toLocaleString();
                $priceSlider.slider('values', 0, 0); // reset sets min handle
                $priceSlider.slider('values', 1, priceRangeValues.length - 1); // reset set max handle
                $priceValues.find('#price-range-min').val(priceMinFormatted); // set min handle value
                $priceValues.find('#price-range-max').val(priceMaxFormatted); // set max handle value
                // Update Slider Labels
                rangeSliderLabels($priceSlider, priceRangeValues);
            });
        }

        // Form on change
        $formRYI.find('input, select').on("change", function() {

            //$('.webform-client-form input[name="submitted[form_data]"]').val(''); // clear field

                //var formObj = objectifyForm( $formRYI.serializeArray() );
                // var formTest = $formRYI.find(':not(.prefill-skip)').serializeArray().filter(function(field) {
                //     return $.trim(field.value) != ""; // exclude empty fields
                // })
                var formData = objectifyForm( $formRYI );
                var form_page =  $formRYI.find('input[name="page_url"]').val();
                var form_data_ouput = form_page+'?form_prefill=1&form_data='+formData;			 

                $formRYI.find('input[name="form_data"]').val(form_data_ouput); // update field

        });
    }

});

